import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import styled from 'styled-components';

import RoutingGroup from 'models/routing_group';
import SelectHeader from 'components/admin/lib/select_header';
import Chip from 'components/common/chip';

const defaultFilterOptions = ReactSelect.defaultProps.filterOptions;

function UserEditorInboxSelector({ inboxes, isDisabled, onChange, value }) {
  if (!inboxes.length) {
    return null;
  }

  const filterOptions = disabledFilterOptions;

  return (
    <div className="userEditor-inboxes">
      <SelectHeader onClearSelected={onClearSelected} selectedCount={value.length} title="Inboxes" />
      <ReactSelect
        backspaceToRemoveMessage=""
        className="userEditor-inboxes-selection is-multi"
        clearable={false}
        disabled={isDisabled}
        filterOptions={filterOptions}
        matchProp="label"
        multi
        name="inboxes"
        onChange={onChangeOptions}
        options={getInboxOptions(inboxes, value)}
        placeholder={isDisabled ? 'Selecting inboxes is disabled' : 'Type or select inboxes'}
        searchPromptText="Type inbox name"
        value={value}
        valueComponent={renderChipValue}
      />
    </div>
  );

  function onChangeOptions(options) {
    onChange(_.map(options, option => option.value));
  }

  function onClearSelected() {
    onChange([]);
  }

  function disabledFilterOptions(options, filterValue, excludeOptions, props) {
    return _.filter(defaultFilterOptions(options, filterValue, excludeOptions, props), option => !option.disabled);
  }
}

const ValueChip = styled(Chip)`
  margin-right: ${p => p.theme.spacing.inlineSmall};
  margin-bottom: ${p => p.theme.spacing.stackSmall};
`;

function renderChipValue({ id, disabled, value, onRemove }) {
  return (
    <ValueChip
      onMouseDown={onChipDown}
      key={id}
      label={value.label}
      onDelete={() => onRemove(value)}
      disabled={disabled}
    />
  );
}

function onChipDown(e) {
  // Need to handle onMouseDown otherwise it opens the menu every click even for delete
  e.stopPropagation();
}

UserEditorInboxSelector.propTypes = {
  inboxes: PropTypes.arrayOf(PropTypes.instanceOf(RoutingGroup)).isRequired,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

function getInboxOptions(inboxes, ids) {
  return _.map(inboxes, inbox => {
    return {
      label: inbox.name,
      value: inbox.id,
      disabled: inbox.disabled,
    };
  });
}

export default UserEditorInboxSelector;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/user_editor/user_editor_inbox_selector.jsx